<template>
	<div class="container-fluid bg-white" :class="{'is-panel': isPanel}">
		<messages-toolbar v-if="!isPanel"></messages-toolbar>

		<div v-if="threadNotFound" class="text-center">
			<i class="fa fa-exclamation-triangle"></i>
			<p>Message thread not found, or it is private</p>
			<p><router-link to="/messages">Back to messages</router-link></p>
		</div>
		<collapsible-panel 
			:hide-handle-on-mobile="true" 
			:external-toggle="threadPanelToggle"
			v-on:panelRetract="threadPanelToggle = false">

			<template slot="panel">
				<div class="thread-list-container">
					<message-thread-list 
						:is-panel="true"
						v-on:selectThread="selectThread">
					</message-thread-list>
				</div>
			</template>
			<template slot="heading">
				<div v-if="$store.activeThread && $store.activeThread.archived == 0" class="context-menu">
					<context-menu 
						v-on:itemClick="contextMenuClick"
						:menu-items="contextMenuItems">
					</context-menu>
				</div>

				<div class="thread-heading" ref="threadHeading">
					<i v-on:click="closeThread" title="Close message thread" class="fa fa-arrow-left icon-button close-active-thread"></i>

					<template  v-if="$store.activeThread">
						<router-link v-if="threadJobLink" :to="threadJobLink" class="thread-title-link-wrapper">
							<h4 class="thread-title">{{threadJobNum}}: {{ $store.activeThread.subject }}</h4>
						</router-link>
						<div v-else-if="threadRecordLink" class="thread-inner-container">
							<router-link :to="threadRecordLink"><h4 class="thread-title">{{ $store.activeThread.subject }}</h4></router-link>
							<div><small>this is a comment thread attached to a <router-link :to="threadRecordLink">{{threadRecordLinkType}} record</router-link></small></div>
						</div>
						<h4 v-else class="thread-title">
							{{ $store.activeThread.subject }}
						</h4>
					</template>
					
				</div>

				<div style="clear: both;"></div>
			</template>
			<template slot="main">

				<div  class="main-row">
					<div class="message-panel" :class="{'inactive' : showingMembers}">

						<div v-if="$store.activeThread" class="messages" :class="{
								'full-height': $store.activeThread.archived == 1,
								'shrunk-for-writing-box' : message.length > smallTextBoxLimit,
								'tall-heading': threadRecordLink
							}" ref="messageContainer">

							<p class="text-center">
								<button v-if="!loadingPrevious" class="btn btn-link" v-on:click="loadPreviousMessages">Load previous messages...</button>
								<i v-else class="fa fa-spinner fa-spin"></i>
							</p>

							<message-bubble
								v-for="message in $store.activeThread.Message"
								:key="message.id"
								:message="message"
								v-on:deleteMessageText="deleteMessageText(message)">
							</message-bubble>

							<div v-if="$store.activeThread.archived == 1" class="text-center">
								<hr>
								<p>This thread has been archived and can't be posted to anymore because a member has left. </p>
								<p><a href="#" v-on:click="newThread($store.activeThread)">Start a new thread with current members?</a></p>
							</div>

							<div style="clear: both;"></div>

							<div v-if="!readByListUnknown && readByList" class="text-muted read-by"><small>Read by {{readByList}}</small></div>
						</div>						

						<i v-if="$store.checkingMessages" class="fa fa-spinner fa-spin" style="position: absolute;right:30px;bottom:55px;"></i>

						<form v-if="$store.activeThread && $store.activeThread.archived == 0" 
							class="compose" 
							:class="{expanded:message.length > smallTextBoxLimit}" 
							ref="composeBox"
							v-on:submit.prevent="sendMessage">

							<textarea
								v-on:keyup="checkMessageBoxCharCnt"
								v-on:keydown="sendMsgIfEnter"
								class="write-message-box form-control"
								style="width: 100%;"
								placeholder="Write your message..."
								v-model="message">
							</textarea>

							<div class="upload-box" v-if="!messageImageId">
								<upload-field
									style="outline:none;height: 100%;margin-bottom: 0"
									class="message-upload"
									icon="fa-upload"
									accept="documents/images"
									target="LibraryUpload/save"
									style-type="box"
									:hide-uploading-msg="true"
									v-on:uploaded="fileUploaded($event)">		
								</upload-field>
							</div>
							<div class="send-button-box">
								<button type="submit" class="btn btn-primary btn-lg" style="width: 100%;border-radius: 0" :disabled="buttonDisabled">
									<i class="fas fa-paper-plane"></i>
								</button>
							</div>

						</form>	
					</div>
					<div v-if="$store.activeThread" class="members-panel" :class="{'inactive' : !showingMembers}">
						<a href="#" v-on:click="showingMembers = false" class="back-to-message-button">Back to Message</a>
						<div class="thread-members">
							<p v-if="$store.activeThread.is_open_thread == 0">
								This is a private message. 
								<span v-if="$store.activeThread.service_id > 0 || $store.activeThread.job_id > 0"><a href="#" v-on:click.prevent="toggleThreadPrivacy(true)">Make open</a></span>
							</p>
							<p v-else-if="$store.activeThread.job_id > 0 || $store.activeThread.service_id > 0">
								This is an <strong>open</strong> thread. Anyone working on this job can see it.
								<a href="#" v-on:click.prevent="toggleThreadPrivacy(true)">Make private</a>
							</p>
 
							<thread-member-card v-for="(member,index) in activeThreadMembers" 
								:key="member.id+index"
								:member="member" 
								:last-message-time="$store.activeThread.last_message">
							</thread-member-card>

							<field v-if="$store.activeThread.archived == 0" label="Add User" col-class="stacked" :params="{type:'select', options:addUserOptions}" v-on:change="addUser" v-model="addUserId"></field>
						</div>

					</div>
				</div>
		
			</template>
		</collapsible-panel>	

		<new-message-thread 
			:visible="newThreadModalVisible"
			v-if="newThreadModalVisible" 
			v-on:closeModal="newThreadModalVisible = false"
			:copied-thread="newThreadCopied"
			v-on:newThreadCreated="newThreadModalVisible = false">
		</new-message-thread>

	</div>
</template>

<script>
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import ContextMenu from "@/layout_fragments/ContextMenu"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import NewMessageThread from "@/components/super_components/NewMessageThread"
import MessageThreadList from "@/components/super_components/MessageThreadList"

import ModalDialog from "@/components/ModalDialog"
import UploadField from "@/components/UploadField"
import ImagePanel from "@/components/ImagePanel"

import MessageThreadCard from "@/layout_fragments/messages/MessageThreadCard"
import MessageBubble from "@/layout_fragments/messages/MessageBubble"
import ThreadMemberCard from "@/layout_fragments/messages/ThreadMemberCard"
import JobThreadList from "@/layout_fragments/messages/JobThreadList"

import MessagesToolbar from "./MessagesToolbar"
import MessageMixins from "@/mixins/MessageMixins.js"

export default {

	name: 'ThreadOpen',
	components: {
		MessagesToolbar,
		CollapsiblePanel,
		ContextMenu,
		TableList,
		Field,
		MessageThreadCard,
		MessageBubble,
		ThreadMemberCard,
		JobThreadList,
		ModalDialog,
		NewMessageThread,
		MessageThreadList,
		UploadField,
		ImagePanel
	},
	mixins: [MessageMixins],
	props: ["isPanel","threadSlug"],
	data() {
		return {
			apiRoot: window.apiRoot,
			threadPanelToggle: false,
			message: "",
			threadFields: [
				{label:"Profile Image",key:"image"},
				{label:"Users",key:"users"},
			],
			threadJobLink: null,
			threadJobName: null,
			threadRecordLink: null,
			threadRecordLinkType: "",
			addUserId: null,
			userActive: null,
			messagePolling: null,
			showNoMessages: false,
			userFields: ["id","slug","first_name","last_name","image_id","last_active","last_read"],
			threadInclude: [
				{model: "User",fields: ["id","slug","first_name","last_name","image_id","last_active","last_read"]},
				{model: "Job",fields:["id","slug","job_name","job_num"]},
				{model: "Service",fields:["id","slug","job_name","job_num"]}
			],
			newThreadModalVisible: false,
			newThreadCopied: false,
			showingMembers: false,
			messageBoxSize: "60px",
			buttonDisabled: false,
			previousMessagePage: 1,
			loadingPrevious: false,
			messageImageId: false,
			messageImageFilename: "",
			smallTextBoxLimit: 30,
			mobileBreakpoint: 991,
			threadNotFound: false,
			readByList: "",
			readByListUnknown: true //set to true when a new message is just sent out, and will be toggled back when fresh poll has been made
		}
	},
	watch: {
		isPanel() {
			this.setThreadPanelToggle()
		},
		threadSlug() {
			if (this.threadSlug)
				this.localThreadSlug = this.threadSlug
		}
	},
	computed: {
		contextMenuItems() {
			let items = []
			if (this.isPanel) {
				items.push({text:'Expand',icon:'fa-expand',clickFunction: 'gotoMessage'})
			}

			items.push({text: 'Leave Thread',icon:'fa-sign-out-alt',clickFunction:'leaveThread'})

			if (window.innerWidth < this.mobileBreakpoint || this.isPanel) {
				
				if (!this.showingMembers)
					items.push({text: 'Manage Members',icon:'fa-users',clickFunction:'toggleToMembers'})
				else
					items.push({text: "Back to Message",icon: 'fa-envelope',clickFunction:'toggleToMessage'})
			}

			return items
		},
		searchPlaceholder() {
			if (this.$store.activeThread)
				return "Search this thread..."
			else
				return "Search all threads..."
		},
		addUserOptions() {
			let vm = this
			return vm.userOptions().filter(user => {
				let include = true

				if (vm.$store.activeThread.Members) {
					vm.$store.activeThread.Members.forEach(member => {
						if (member.id == user.value) 
							include = false
						
					})
					return include
				}
			})
		},
		activeThreadMembers() {
			let vm = this

			if ("Members" in this.$store.activeThread) {

				return this.$store.activeThread.Members.map(user => {

					if (user.image_id > 0) {
						//match with profile image
						if (vm.$store.profileImages) {
							vm.$store.profileImages.forEach(image => {

								if (image.id == user.image_id)
									vm.$set(user,"imageUrl",window.apiRoot+"resources/profile-images/"+image.slug+"/"+image.filename)

							})
						}
						
					}

					return user
				})

			}
			else
				return []
		}
	},
	methods: {
		setThreadPanelToggle() {
			if (!this.isPanel && window.innerWidth > this.mobileBreakpoint) 
				this.threadPanelToggle = true
			else
				this.threadPanelToggle = false
		},
		toggleThreadPrivacy(isPrivate) {
			let payload = {
				is_open_thread: 0,
				id: this.$store.activeThread.id
			}

			if (!isPrivate)
				payload.is_open_thread = 1

			let vm = this

			this.postData("MessageThread/save",payload,true).then(response => {
				if (response.success) {
					vm.$store.activeThread.is_open_thread = payload.is_open_thread
				}
			})
		},
		computeReadByList() {
			let vm = this

			let readBy = this.$store.activeThread.Members.filter(member => vm.moment(member.last_read).isAfter(vm.$store.activeThread.last_message)).map(member => member.first_name + " " + member.last_name)

			let readByLimit = 5
			if (readBy.length > readByLimit) {
				let othersCount = readBy.length - readByLimit

				this.readByList = readBy.slice(0,5).join(", ")+" and "+othersCount+" others"
			}
			else
				this.readByList = readBy.join(", ")

		},
		checkMessageBoxCharCnt() {
			if (this.message.length > 30)
				this.messageBoxSize = "60px" //make writing textbox bigger
			else
				this.messageBoxSize = "150px"

		},
		contextMenuClick(clickFunction) {
			this[clickFunction]()
		},
		sendMsgIfEnter(key) {
			if (
				(key.code == "Enter" && !key.shiftKey && !key.ctrlKey) 
				|| 
				(key.code == 'NumpadEnter' && !key.shiftKey && !key.ctrlKey)) {
				
				key.preventDefault()
				this.sendMessage()
			}
		},
		sendMessage() {
			let vm = this

			if (!this.buttonDisabled) {

				let payload = {
					message: this.message,
					author_id: this.$store.userDetails.id,
					thread_id: this.$store.activeThread.id
				}

				if (this.messageImageId)
					payload.image_id = this.messageImageId

				this.buttonDisabled = true

				this.readByListUnknown = true

				this.readByList = this.$store.userDetails.first_name+" "+this.$store.userDetails.last_name

				this.postData("Message/save",payload,true).then(response => {
					if (response.success) {

						vm.message = ""

						vm.messageImageId = false

						vm.fetchNewThreadMessages()
						vm.fetchThreadMembers()
					}
					vm.buttonDisabled = false
				})
			}
		},
		deleteMessageText(message) {
			let vm = this

			let deleteMsg = "[message contents deleted by author]"

			let payload = {
				id: message.id,
				thread_id: message.thread_id,
				message: deleteMsg
			}

			this.postData("Message/save",payload).then(response => {
				if (response.success) {
					let index = vm.$store.activeThread.Message.findIndex(msg => msg.id == message.id)

					vm.$store.activeThread.Message[index].message = deleteMsg
				}
			})
		},
		fileUploaded(response) {
			this.messageImageId = response.data.id
			this.messageImageFilename = response.data.filename

			this.sendMessage()
		},
		gotoMessage() {
			this.$emit('closePanel')
			this.$router.push("/message/"+this.threadSlug)
		},
		toggleToMembers() {
			this.showingMembers = true
		},
		toggleToMessage() {
			this.showingMembers = false
		},
		newThread(copiedThread) {
			this.newThreadModalVisible = true

			this.newThreadCopied = copiedThread
		},
		addUser() {
			let vm = this

			vm.$nextTick(() => {

				vm.$store.users.forEach(user => {
					if (user.id == vm.addUserId) {
						vm.$store.activeThread.Members.push(user)
					}
				})
				vm.addUserId = null

				let idList = vm.$store.activeThread.Members.map(member => {
					return member.id
				})

				let payload = {
					id: vm.$store.activeThread.id,
					Members: idList
				}

				this.saveRecord("MessageThread",payload,response => {
					vm.alertSuccess("User added to thread!")
				})
			})
			
		},
		leaveThread() {
			let vm = this

			let payload = {
				id: vm.$store.activeThread.id
			}

			this.postData("MessageThread/leave",payload).then(response => {
				vm.$store.activeThread = false

				if (!vm.isPanel)
					vm.$router.push("/messages")
				else
					vm.closeThread()

			})

		},
		fetchThreadMembers() {
			let vm = this

			let params = {
				include: [{model: "User",fields:this.userFields}],
				fields: ["slug","last_message","last_message_by","User","Members","is_comment_thread","is_open_thread"]
			}

			if (this.$store.activeThread) {
				this.getJSON("MessageThread/find/"+this.$store.activeThread.slug,params).then(response => {
					if (response.success) {
						vm.$store.activeThread.Members = response.data.Members
						vm.$store.activeThread.last_message = response.data.last_message

						vm.computeReadByList()

						vm.readByListUnknown = false
					}
				})
			}
		},
		fetchNewThreadMessages(long_poll) {
			//we're going to not use the spinner so it works quietly in the background

			let vm = this

			if (this.$store.activeThread) {

				if (!this.$store.longPollInProgress || !long_poll) {
					
					if (long_poll) {
						this.$store.longPollInProgress = true
						this.$store.longPollSource = "ThreadOpen"
					}

					let params = {
						filters: [
							["thread_id",vm.$store.activeThread.id],
							["created_at >",vm.$store.lastMessageFetch]
						],
						include: [
							"LibraryUpload",
							{model:"User",fields: vm.userFields},
							{model: "MessageThread",fields:["id","slug","last_message","Members","is_comment_thread","comment_parent_model","comment_parent_slug"],include:vm.threadInclude}
						]
					}

					if (long_poll)
						params.wait = true
					else
						params.wait = false

					this.getJSON("Message/get",params).then(response => {
						vm.showNoMessages = true

						if (params.wait)
							vm.$store.longPollInProgress = false

						//remove duplicate messages -- FIND A BETTER WAY TO DO THIS
						if (response.success) {
							let newMessages = response.data.filter(message => {
								let keep = true
								if (vm.$store.activeThread) {
									vm.$store.activeThread.Message.forEach(existingMessage => {
										if (existingMessage.id == message.id)
											keep = false
									})
								}
								return keep
							})

							if (vm.$store.activeThread && "Message" in vm.$store.activeThread && vm.$store.activeThread.Message) {
								vm.$store.activeThread.Message = vm.$store.activeThread.Message.concat(newMessages)

								if (response.data.length > 0 && 
									"MessageThread" in response.data[0] && 
									response.data[0].MessageThread &&
									"Members" in response.data[0].MessageThread.Members)
									vm.$store.activeThread.Members = response.data[0].MessageThread.Members
							}
						}

						vm.markAsRead()
						vm.fetchThreadMembers()

						vm.$forceUpdate();

						if (vm.$store.activeThread)
							vm.matchProfileImages(vm.$store.profileImages,vm.$store.activeThread.Message)

						//only scroll to bottom if new message is appended, otherwise we don't want to mess with scroll
						if (response.data.length > 0) {
							vm.$nextTick(() => {
								//scroll message window to bottom
								let messageContainer = vm.$refs.messageContainer

								if (typeof messageContainer != 'undefined')
									messageContainer.scrollTop = messageContainer.scrollHeight;
							})	
						}

						vm.$store.lastMessageFetch = response.time

						if (params.wait && vm.$store.threadOpenComponentOpen) {
							vm.fetchNewThreadMessages(true)
						}

					})
				}

			}
		},
		loadPreviousMessages() {
			this.previousMessagePage++;

			let vm = this

			let messageInclude = JSON.stringify();

			let messageFilters = JSON.stringify([
				["thread_id",this.$store.activeThread.id] //of this thread
			])

			let messageOrders = JSON.stringify()

			let params = {
				include: [
					{model:"User",fields:vm.userFields},
					"LibraryUpload"
				],
				filters: [
					["thread_id",this.$store.activeThread.id]
				],
				orders: [
					["created_at","DESC"]
				],
				page: this.previousMessagePage
			}

			this.loadingPrevious = true

			this.getJSON("Message/get",params,true).then(response => {
				vm.loadingPrevious = false

				//reverse and prepend to messages array
				if (response.success) {
					let reversed = response.data.reverse()

					let allTogether = reversed.concat(vm.$store.activeThread.Message)

					vm.$store.activeThread.Message = allTogether

					vm.$forceUpdate()
				}
			})
		},
		selectThread(thread) {
			let vm = this

			this.spinner(true)

			if (!this.isPanel)
				vm.$router.push("/message/"+thread.slug)

			vm.$store.activeThread = thread

			//fetch user avatars
			let filters = []

			let imageIds = thread.Members.filter(member => member.image_id != 0).map(member => member.image_id)

			let imageProfileParams = {
				filters: ["id",imageIds]
			}

			filters = JSON.stringify(filters)

			let params = {
				include: [
					{model:"User",fields:vm.userFields},
					"LibraryUpload"
				],
				filters: [
					["thread_id",thread.id]
				],
				orders: [
					["created_at","DESC"]
				],
				page: 1
			}

			let promises = [
				this.getJSON("Message/get",params)
			]

			let profileImagePromiseIndex = false
			if (imageIds.length > 0) {

				promises.push(this.getJSON("ProfileImage/get",imageProfileParams))

				profileImagePromiseIndex = 1
			}

			let jobParams = {
				fields: ["id","slug","job_num"]
			}

			let jobFindPromiseIndex = false
			if (thread.job_id > 0) {
				promises.push(this.getJSON("Job/find/"+thread.job_id,jobParams))
				jobFindPromiseIndex = promises.length - 1
			}

			else if (thread.service_id > 0) {
				promises.push(this.getJSON("Service/find/"+thread.service_id,jobParams))
				jobFindPromiseIndex = promises.length - 1
			}

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				thread.Message = responses[0].data.reverse()

				if (profileImagePromiseIndex !== false)
					vm.$store.profileImages = responses[profileImagePromiseIndex].data

				vm.matchProfileImages(vm.$store.profileImages,thread.Message)

				//scroll message window to bottom
				vm.$nextTick(() => {
					let messageContainer = vm.$refs.messageContainer
					if (typeof messageContainer != 'undefined')
						messageContainer.scrollTop = messageContainer.scrollHeight;
				})	

				//record the timestamp of the response so we know where to filter for new messages
				vm.$store.lastMessageFetch = responses[0].time

				vm.markAsRead()

				vm.computeReadByList()

				vm.$store.currentMessagePollingInterval = this.messageSettings.fastPolling

				if (thread.is_comment_thread == 1) {
					vm.threadJobLink = false

					//maps a model to the route to get to a record in the model. Route will be compiled like so:
					// link[0]+slug+link[1]
					let linkMap = {
						Expense: ['/expenses/list/'],
						TimeLog: ['/time-logs/list/'],
						Equipment: ['/equipment/edit/'],
						LibraryFile: ['/library/file/'],
						Contact: ['/contact/','/details'],
						ServiceInvoice: ["/service/",'/invoice'],
						PurchaseOrder: ["/project/","/purchase-orders/"],
						ServiceContract: ["/service-contract/","/details"]
					}

					if (thread.comment_parent_model == 'ServiceInvoice' || thread.comment_parent_model == "PurchaseOrder") {
						//service invoices are routed by parent service slug, not the invoice slug, so we have to handle the link differently
						vm.getJSON(thread.comment_parent_model+"/find/"+thread.comment_parent_slug).then(response => {

							let grandparentModel = ""
							let finalSegment = ""
							let linkField = ""
							if (thread.comment_parent_model == "ServiceInvoice") {
								grandparentModel = "Service"
								linkField = "service_id"
							}
							else {
								grandparentModel = "Job"
								linkField = "job_id"
								finalSegment = thread.comment_parent_slug
							}

							let isQuote = false
							if ("is_quote" in response.data && response.data.is_quote == 1)
								isQuote = true

							vm.getJSON(grandparentModel+"/find/"+response.data[linkField]).then(grandparentResponse => {
								let slug = grandparentResponse.data.slug

								vm.threadRecordLink = linkMap[thread.comment_parent_model][0]+slug

								if (thread.comment_parent_model == 'ServiceInvoice' && isQuote)
									vm.threadRecordLink = "/service/"+slug+"/quote"
								else if (linkMap[thread.comment_parent_model].length > 1) //append second part of route after the slug
									vm.threadRecordLink += linkMap[thread.comment_parent_model][1]+finalSegment
							})
						})
					}
					else {
						vm.threadRecordLink = linkMap[thread.comment_parent_model][0]+thread.comment_parent_slug
						if (linkMap[thread.comment_parent_model].length > 1) //append second part of route after the slug
							vm.threadRecordLink += linkMap[thread.comment_parent_model][1]
					}
					vm.threadRecordLinkType = vm.modelMap[thread.comment_parent_model]
				}

				if (jobFindPromiseIndex !== false && responses[jobFindPromiseIndex].success) {

					if (thread.job_id > 0) 
						vm.threadJobLink = "/project/"+responses[jobFindPromiseIndex].data.slug+"/dashboard"
					
					else if (thread.service_id > 0)
						vm.threadJobLink = "/service/"+responses[jobFindPromiseIndex].data.slug+"/dashboard"
					vm.threadJobNum = responses[jobFindPromiseIndex].data.job_num
				}

				vm.fetchNewThreadMessages(true)

				vm.$forceUpdate();
				
			})

		},
		markAsRead() {
			let vm = this

			//send notice that these messages are read now
			if (this.$store.activeThread) {
				let payload = {
					thread_id: vm.$store.activeThread.id
				}
				vm.postData("MessageThreadUser/save",payload)

				//remove this thread out id out of $store.threadsWithNewMessages
				let index = vm.$store.threadsWithNewMessages.indexOf(vm.$store.activeThread.id)
				if (index >= 0)
					vm.$store.threadsWithNewMessages.splice(index)
			}

		},
		closeThread() {
			this.$store.activeThread = null

			this.$store.currentMessagePollingInterval = this.messageSettings.slowPolling

			if (!this.isPanel)
				this.$router.push("/messages")
			else
				this.$emit("threadClosed")
		},
		fetchData() {
			this.spinner(true)

			let vm = this

			let promises = [
				this.getJSON("MessageThread/find/"+this.localThreadSlug,{include:vm.threadInclude}),,
				this.fetchUsers([],false,vm.userFields),
				this.fetchJobs([],false,["job_name","job_num"])
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (!responses[0].success) {
					vm.threadNotFound = true
					vm.$router.push("/messages")
				}

				else {
					vm.threadNotFound = false
					vm.selectThread(responses[0].data)
				}

				vm.showNoMessages = true

				vm.readByListUnknown = false
				
			})

		},

	},
	created() {

		if (this.threadSlug)
			this.localThreadSlug = this.threadSlug
		else if ("threadSlug" in this.$route.params)
			this.localThreadSlug = this.$route.params.threadSlug

		this.fetchData()

		this.setThreadPanelToggle()

		let vm = this
		this.$bus.$on("checkNewMessages",() => {

			if (vm.$store.activeThread)
				vm.fetchNewThreadMessages(false)
		})

		this.$bus.$on("reloadMessages",() => {
			vm.$store.activeThread = null
			if (!vm.isPanel)
				vm.$router.push('/messages')
		})

		if (!this.isPanel)
			this.$bus.$emit("closeMessagePanel")

		/*
		* when fetchNewThreadMessages() calls itself, it does so even if this component is destroyed, so it will run forever. Therefore we need to track the threadOpen component state in the store, so we know if we should stop recursively calling fetchNewThreadMessages()
		*/
		this.$store.threadOpenComponentOpen = true
	},
	destroyed() {
		/*
		* when fetchNewThreadMessages() calls itself, it does so even if this component is destroyed, so it will run forever. Therefore we need to track the threadOpen component state in the store, so we know if we should stop recursively calling fetchNewThreadMessages()
		*/
		this.$store.threadOpenComponentOpen = false

		this.$store.currentMessagePollingInterval = this.messageSettings.slowPolling
	}
}
</script>

<style type="text/css">

	.thread-list-container {
		overflow-y: auto;
		max-height: calc(100vh - 109px);
		margin-right: -10px;
		margin-left: -10px;
	}

	.message-panel .messages {
		background-color: #f8f9fa;
		padding: 15px;
		border: 1px solid #e0e0e0;
		height: calc(100vh - 196px); 
		overflow-y: auto;
		margin-left: -15px;
		width: calc(100% + 15px);
		position: relative;
	}

	.message-panel .messages.tall-heading {height: calc(100vh - 214px);}

	.message-panel .messages.shrunk-for-writing-box {height: calc(100vh - 266px);}

	.message-panel .messages.shrunk-for-writing-box.tall-heading {height: calc(100vh - 284px);}

	.messages.full-height {height: calc(100vh - 144px); }

	/*.message-panel .messages.no-toolbar {height: calc(100vh - 145px); }

	.message-panel .messages.tall-heading.no-toolbar {height: calc(100vh - 169px);}

	.message-panel .messages.shrunk-for-writing-box.no-toolbar {height: calc(100vh - 215px);}

	.message-panel .messages.shrunk-for-writing-box.tall-heading.no-toolbar {height: calc(100vh - 239px);}

	.messages.full-height.no-toolbar {height: calc(100vh - 99px);}*/

	.main-row {
		margin-right: -15px;
	}

	.close-active-thread {
		position: static;
		left: 0px;
		top: -6px;
		z-index: 10;
		margin-right: 10px;
		vertical-align: top;
	}

	.thread-title,
	.thread-title-link-wrapper {
		display: inline-block;
		margin-bottom: 0;
		white-space: nowrap;
	    overflow-x: hidden;
	    max-width: calc(100% - 50px);
	    text-overflow: ellipsis;
	}

	.thread-title-link-wrapper .thread-title {
		max-width: 100%;
	}

	.normal-threads {
		margin-bottom: 10px;
	}

	.user-selector-col {
		display: inline-block;
		width: calc(100% - 214px);
	}

	.user-add-remove-button-col {
		display: inline-block;
		width: 210px;
	}

	.compose {
		display: flex;
		flex-direction: row;
		align-items: stretch;
		margin-left: -15px;
		height: 50px;
		width: calc(100% + 10px);
	}

	.send-button-box {
		position: relative;
		z-index: 5; /*So upload input doesn't overlay on top of button */
	}

	.compose .write-message-box, .compose .send-button-box {
		display: inline-block;
		vertical-align: top;
		margin-top: -1px;
	}

	.compose .write-message-box {
		width: calc(100% - 60px);
	}

	.compose.expanded {
		height: 120px;
	}

	.compose .send-button-box {
		width: 80px;
		display: flex;
		margin-right: -5px;
	}

	.compose .send-button-box button, .compose .attachment-box button {
		height: 100%;
	}

	.context-menu {
		position: absolute;
		right: -10px;
	}

	.thread-heading {
		margin-left: 25px;
		vertical-align: top;
		margin-bottom: 10px;
	}

	.thread-inner-container {
		display: inline-block;
		width: calc(100% - 50px);
	}

	.panel-open .thread-heading {
		margin-left: 0;
	}

	.message-panel .upload-field {
		position: absolute;
		bottom: 5px;
		left: 5px;
		right: 15px;
	}

	.upload-box {
		width: 50px;
	}

	.main-row .message-panel, .main-row .members-panel {
		display: inline-block;
		vertical-align: top;
	}

	.main-row .message-panel {
		width: calc(100% - 324px);
		vertical-align: top;
	}

	.main-row .members-panel {
		width: 300px;
		margin-left: 10px;
		margin-right: 10px;
		vertical-align: top;
	}

	.back-to-message-button {
		display: none;
	}

/* PANEL STYLES: (same as narrow media queries);*/

	.is-panel .message-panel .messages {
		height: calc(100vh - 196px);
	}

	.is-panel .message-panel .messages.tall-heading {
		height: calc(100vh - 240px); 
	}

	.is-panel .message-panel .messages.shrunk-for-writing-box {
		height: calc(100vh - 266px);
	}

	.is-panel .message-panel .messages.shrunk-for-writing-box.tall-heading {
		height: calc(100vh - 310px);
	}

	.is-panel .user-selector-col, 
	.is-panel .user-add-remove-button-col {
		display: block;
		width: 100%;
		text-align: right;
	}

	.is-panel .back-to-message-button {
		display: block;
	}

	.is-panel .main-row .members-panel {
		width: calc(100% - 15px);
		display: block;
		margin: 0;
	}

	.is-panel .main-row .members-panel.inactive, 
	.is-panel .main-row .message-panel.inactive {
		display: none;
	}

	.is-panel .main-row .message-panel {
		width: 100%;
		display: block;
	}

	.is-panel .row.main-row {
		margin-right: -30px;
	}

	.is-panel .thread-heading {
		margin-left: 0;
	}

	.is-panel .message-panel.inactive {
		display: none;
	}

	.is-panel .members-panel.inactive {
		display: none;
	}

	.is-panel .thread-top-buttons {
		margin-right: 30px;
	}

	.is-panel .thread-members {
		margin-top: 15px;
	}

	.is-panel .compose .write-message-box {
		width: calc(100% - 35px);
		margin-right: -5px;
	}

	.is-panel .compose .send-button-box {
		width: 60px;
		margin-right: -5px;
	}

	.is-panel .compose .upload-box {
		margin-left: 5px;
	}

	.is-panel .compose .send-button-box button span {
		display: none;
	}	

/* END PANEL STYLES ***********************/


	@media (max-width: 1199px) {
		.message-panel .messages {
			height: calc(100vh - 201px); 
		}

		.message-panel .messages.tall-heading {
			height: calc(100vh - 219px); 
		}

		.message-panel .messages.shrunk-for-writing-box {
			height: calc(100vh - 271px);
		}

		.message-panel .messages.shrunk-for-writing-box.tall-heading {
			height: calc(100vh - 289px);
		}
	}

	@media (max-width: 991px) {
		.user-selector-col, .user-add-remove-button-col {
			display: block;
			width: 100%;
			text-align: right;
		}

		.back-to-message-button {
			display: block;
		}

		.main-row .members-panel {
			width: calc(100% - 15px);
			display: block;
			margin: 0;
		}

		.main-row .members-panel.inactive, .main-row .message-panel.inactive {
			display: none;
		}

		.main-row .message-panel {
			width: 100%;
			display: block;
		}
	}

	@media (max-width: 767px) {

		.message-panel .messages {
			height: calc(100vh - 196px); 
		}

		.row.main-row {
			margin-right: -30px;
		}

		.thread-heading {
			margin-left: 0;
		}

		.message-panel.inactive {
			display: none;
		}

		.members-panel.inactive {
			display: none;
		}

		.thread-top-buttons {
			margin-right: 30px;
		}

		.thread-members {
			margin-top: 15px;
		}

		.compose .write-message-box {
			width: calc(100% - 35px);
			margin-right: -5px;
		}

		.compose .send-button-box {
			width: 60px;
			margin-right: -5px;
		}

		.compose .upload-box {
			margin-left: 5px;
		}

		.compose .send-button-box button span {
			display: none;
		}
	}
	
</style>
